// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'user',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    Object: 'value',
    label: '',
    width: '120'
  }, {
    prop: 'coupon_code',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'coupon_type',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'discount',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'target_amount',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'validity',
    label: '',
    Object: 'value',
    width: '280'
  }, {
    prop: 'price',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'usable_status',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'remarks',
    label: '',
    Object: 'value',
    width: '200'
  }]
}
